import { axiosClient } from "@/shared/api/axios-client";
import type { Prorrateo } from "@/lib/types";

/**
 * Endpoint para listar todos los prorrateos de la solicitud (uno por
 * CFDI). Solo aplica al subtipo MULTIPLES_CFDI · el subtipo único
 * usa `prorrateoApi.obtener` que devuelve un solo Prorrateo.
 */
/**
 * Un renglón de la plantilla de dispersión multi-factura: folio del CFDI, concepto (por número ·
 * 0 si el CFDI tiene un solo concepto), CeCo por código, cuenta contable por código (opcional ·
 * hereda la del concepto) e importe.
 */
export interface FilaDispersionMultipleInput {
  conceptoNumero: number;
  centroDeCostoCodigo: string;
  cuentaContableCodigo?: string;
  importe: number;
  numeroFactura: string;
}

export interface DispersionMultipleResultado {
  slotsActualizados: number;
  lineasTotales: number;
}

export const prorrateoMultipleApi = {
  listar: (solicitudId: string) =>
    axiosClient
      .get<Prorrateo[]>(`/api/solicitudes/${solicitudId}/prorrateo/todos`)
      .then((r) => r.data),

  /**
   * Carga la dispersión de CeCos de TODAS las facturas desde una sola plantilla
   * Excel (paridad legado · subtipo Múltiples CFDI). El backend empata cada
   * renglón con su slot por el folio del CFDI y reemplaza las líneas de cada
   * prorrateo. Las sumas se validan al confirmar cada slot.
   */
  importarDispersionMultiple: (solicitudId: string, filas: FilaDispersionMultipleInput[]) =>
    axiosClient
      .post<DispersionMultipleResultado>(
        `/api/solicitudes/${solicitudId}/prorrateo/importar-dispersion-multiple`,
        { filas }
      )
      .then((r) => r.data),
};
